import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Copy1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 4.5L21 4.5V13.5H19.5V15H21C21.8274 14.9975 22.4975 14.3274 22.5 13.5V4.5C22.4975 3.6726 21.8274 3.00247 21 3H9C8.1726 3.00247 7.50247 3.6726 7.5 4.5V6L9 6L9 4.5ZM16.5 7.5H3C2.1726 7.50247 1.50247 8.1726 1.5 9V19.5C1.50247 20.3274 2.1726 20.9975 3 21H16.5C17.3274 20.9975 17.9975 20.3274 18 19.5V9C17.9975 8.1726 17.3274 7.50247 16.5 7.5ZM3 19.5H16.5V9H3V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Copy1.vue"]]);
